import React from 'react';
import Icon from '../../../components/AppIcon';

const PriorityAlerts = ({ alerts }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high':
        return {
          bg: 'bg-destructive/10',
          text: 'text-destructive',
          border: 'border-destructive/20'
        };
      case 'medium':
        return {
          bg: 'bg-warning/10',
          text: 'text-warning',
          border: 'border-warning/20'
        };
      default:
        return {
          bg: 'bg-muted',
          text: 'text-muted-foreground',
          border: 'border-border'
        };
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'overdue':
        return 'AlertTriangle';
      case 'expiring':
        return 'Calendar';
      case 'assessment':
        return 'ClipboardCheck';
      case 'compliance':
        return 'Shield';
      default:
        return 'AlertCircle';
    }
  };

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-semibold text-foreground">Priority Alerts</h2>
        <button className="inline-flex items-center gap-2 px-3 py-1.5 bg-card border border-border rounded-lg hover:bg-muted transition-colors text-sm">
          <Icon name="Filter" size={16} />
          <span>Filter</span>
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {alerts?.map((alert) => {
          const colors = getSeverityColor(alert?.severity);
          return (
            <div
              key={alert?.id}
              className={`bg-card border ${colors?.border} rounded-lg p-5 hover:shadow-lg transition-shadow`}
            >
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 rounded-lg ${colors?.bg} flex items-center justify-center flex-shrink-0`}>
                  <Icon name={getTypeIcon(alert?.type)} size={24} className={colors?.text} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-2">
                    <h3 className="text-base font-semibold text-foreground">{alert?.title}</h3>
                    <span className={`px-2 py-1 ${colors?.bg} ${colors?.text} text-xs font-medium rounded-full flex-shrink-0`}>
                      {alert?.count}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-3">{alert?.description}</p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2 text-xs text-muted-foreground">
                      <Icon name="Clock" size={14} />
                      <span>Due: {alert?.dueDate}</span>
                    </div>
                    <button className={`px-3 py-1.5 ${colors?.bg} ${colors?.text} rounded-lg hover:opacity-80 transition-opacity text-xs font-medium`}>
                      {alert?.action}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PriorityAlerts;